import { render, staticRenderFns } from "./BoatForm.vue?vue&type=template&id=6a60863f"
import script from "./BoatForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoatForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports